// extracted by mini-css-extract-plugin
export default {"panelItemClassName":"src-components-LineCollapse-css__panelItemClassName--kF2wO"};